import { Fragment, useEffect, useState } from "react";
import styles from "./Statement.module.css";
import store from "../../Store/Store";
import axios from "axios";
import config from "../../config/config";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../useDebouncedLog";
import AddRemark from "./AddRemark";
import KeyValueClient from "../../services/KeyValueClient.js";
import { useCsvEditor, verifyTokenAccess } from '../../Helper.js';
const Statement = observer(() => {
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedmonth] = useState("");
  const [gotResponse, setGotResponse] = useState(false);
  const [data, setData] = useState();
  const [Clicked, setClicked] = useState(false);
  const [ShowSuccess, setShowSuccess] = useState(false);
  const [ClickedStmt, setClickedStmt] = useState("");
  const [Remarks, setRemarks] = useState();
  const [Error, setError] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState({});
  const [DownloadingProgess, setDownloadingProgess] = useState(false);
  const [EditRemark, setEditRemark] = useState(false);
  const [category, setCategory] = useState()
  const [EmployeeInfo, setEmployeeInfo] = useState()
  // {
  //   Title: "Network issue",
  //   message: "Poor or lost internet connection during download",
  // }    ErrorMsg example

  const getCategories = async () => {
    try {
      let tokens = localStorage.getItem("authToken");
      await verifyTokenAccess("Statements getCategory")
      let parsedTokens = JSON.parse(tokens);
      const Obj = {
        ledger_label: store.Company_Id,
      };
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_categories`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then((res) => {
          // setData(res?.data?.data);
          // console.log("res.data", res.data.data)
          try {
            let intialData = res?.data?.data
            let final_obj = {}
            for (let i = 0; i < intialData.length; i++) {
              final_obj[intialData[i].categoryId] = { CategoryName: intialData[i].categoryName ? intialData[i].categoryName : "", gl_code: intialData[i].gl_code ? intialData[i].gl_code : "" }
            }
            setCategory(final_obj)
          } catch (err) {
            console.log("get category", err);

          }
        })
        .catch((err) => {
          console.log("Error %o", err);
        });
    } catch (err) {
      console.log("error %o", err);
    }
  };
  const getUsersEmpDetail = async () => {

    const obj = {
      ledger_label: store.Company_Id,
    };
    let tokens = localStorage.getItem("authToken");
    await verifyTokenAccess("Statements UseEmp Detail")
    let parsedTokens = JSON.parse(tokens);
    if (!tokens) {
      console.log("no auth");
      navigate("/login");
      return;
    } else {
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
    }
    try {
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_compnay_users`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then(async (res) => {
          let intialData = res?.data?.data
          let final_obj = {}
          for (let i = 0; i < intialData.length; i++) {
            final_obj[intialData[i].mobile_no] = intialData[i]?.employee_info ? intialData[i]?.employee_info : {}
          }
          setEmployeeInfo(final_obj)
        }).catch((err) => {

        })
    } catch (err) {
      console.log("error", err)
    }
  }
  var logStatementsVisited;
  var logStatementsDownloded;
  try {
    logStatementsVisited = useDebouncedLog("admin_statements_visited", 500);
    logStatementsDownloded = useDebouncedLog("admin_statements_downloded", 500);
  } catch (err) {
    console.log("error", err);
  }

  let monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const generateYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  useEffect(() => {
    getUsersEmpDetail()
    getCategories()
    logStatementsVisited();
  }, [logStatementsVisited]);

  useEffect(() => {
    setSelectedYear("");
    setGotResponse(false);
    const startYear = 2025;
    setYearOptions(generateYearOptions(startYear));
  }, [store.refresh]);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  useEffect(() => {
    getRemarks();
  }, []);

  const getRemarks = async (year, month) => {
    if (!year || !month) return;

    let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");
    await verifyTokenAccess("Statements getRemark")

    // let parsedTokens = tokens ? JSON.parse(tokens) : {};
    // if(!parsedTokens){
    //   return
    // }
    const expired = isTokenExpired(tokens.IdToken);

    if (expired) {
      getNewTokens(tokens);
      return;
    }

    const monthNumber = monthOptions.indexOf(month) + 1;
    const formattedMonth = String(monthNumber).padStart(2, "0");
    let key = `${store.Company_Id}${year}${formattedMonth}`;
    try {
      const client = new KeyValueClient(
        config.keystore_endpoint, // ← MUST be Envoy proxy, not 8080
        {
          cognitoToken: tokens.IdToken,
        },
      );
      const data = await client.get(key);
      let parsed_data = JSON.parse(data);
      if (!parsed_data.value) {
        console.log("no value for this ,month");
        return;
      }
      let parsed_value = JSON.parse(parsed_data?.value);
      setRemarks(parsed_value);
    } catch (err) {
      console.log("error", err);
    }
  };
  console.log('endpoint:', config.keystore_endpoint);
  // const getRemarks = (year, month) => {
  //   if (!year || !month) return;

  //   let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");
  // await verifyTokenAccess()
  //   const expired = isTokenExpired(tokens.IdToken);

  //   if (expired) {
  //     getNewTokens(tokens);
  //     return;
  //   }

  //   const monthNumber = monthOptions.indexOf(month) + 1;
  //   const formattedMonth = String(monthNumber).padStart(2, "0");
  //   console.log("year", year);
  //   console.log("formattedMonth", formattedMonth);

  //   let obj = {
  //     ledger_label: store.Company_Id,
  //     year: year,
  //     month: formattedMonth,
  //   };
  //   const payload = {
  //     method: "post",
  //     url: `${config.update_api_endpoint}/store/get_remarks`,
  //     headers: {
  //       aws_cognito_id_token: tokens.IdToken,
  //       aws_cognito_access_token: tokens.AccessToken,
  //       "Content-Type": "application/json",
  //     },
  //     data: obj,
  //   };

  //   axios
  //     .request(payload)
  //     .then((response) => {
  //       console.log("response", response);
  //       setRemarks(response.data.data);
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  const GetStatementsData = (year, month) => {
    setData([]);
    setGotResponse(false);
    // setCombineMessage("");
    // setCombineError("");

    if (!year || !month) return;

    const monthNumber = monthOptions.indexOf(month) + 1;
    const formattedMonth = String(monthNumber).padStart(2, "0");

    const obj = {
      ledger_label: store.Company_Id,
      year: year,
      month: formattedMonth,
    };

    try {
      let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");
      verifyTokenAccess("Statements GEt staments Data")
      const expired = isTokenExpired(tokens.IdToken);

      if (expired) {
        getNewTokens(tokens);
        return;
      }

      const payload = {
        method: "post",
        url: `${config.node_api_endpoint}/cupi/admin/get_monthly_spend_daily`,
        headers: {
          aws_cognito_id_token: tokens.IdToken,
          aws_cognito_access_token: tokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((response) => {
          setGotResponse(true);
          setData(response.data.data || []);
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        });
    } catch (err) {
      console.error("Error:", err);
    }
  };

  let client

  try {
    let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");

    const expired = isTokenExpired(tokens.IdToken);
    if (expired) {
      getNewTokens(tokens);
      return;
    }
    client = new KeyValueClient(
      config.keystore_endpoint,
      {
        cognitoToken: tokens?.IdToken,
      },
    );
  } catch (err) {
    console.log("error wile initilizing KEY Store Client", err);
  }

  const GetUsersTaxUpdate = async (Date, CompanyId, Phonenumber) => {
    try {


      let key = `${Date}_${CompanyId}_${Phonenumber}`

      let response = await client.get(key)
      let parsedRes = JSON.parse(response)
      let parsedValue = parsedRes?.value ? JSON.parse(parsedRes.value) : {}
      return parsedValue ? parsedValue : false
    } catch (er) {
      console.log("error", er);

    }
  }

  // 20260723_EscrowStackPine_8303163980
  // 20260723_EscrowStackPine_8303163980
  const UpdateUsersTransactions = async (data) => {
    let Result = await GetUsersTaxUpdate(20260723, "EscrowStackPine", 8303163980)
    console.log("INVOKED FOR FINDING USER", data)
  }

  const DownloadStatments = async (DocUrl, date, FileName) => {
    let url = DocUrl
    let data = await useCsvEditor(url)
    let usersObj = {}
    console.log("data", data);

    for (let i = 0; i < data.transactions.length; i++) {
      let currentTxn = data.transactions[i]
      let userPhoneNumber = currentTxn["Employee Phone Number"];
      const clean = String(currentTxn["Employee Phone Number"]).replace(/^(\+91|91)/, '');
      let response
      if (!usersObj[currentTxn["Employee Phone Number"]]) {
        response = await GetUsersTaxUpdate(date, store.Company_Id, clean)
      }
      if (!usersObj[currentTxn["Employee Phone Number"]]) usersObj[currentTxn["Employee Phone Number"]] = response ? response : "NA"
    }
    for (let i = 0; i < data.transactions.length; i++) {
      let currentTxn = data.transactions[i]
      let Phonenumber = currentTxn["Employee Phone Number"]
      let payoutref = currentTxn["Payout_Ref"]//currentTxn["Payout Ref"]
      currentTxn.EmployeeCode = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_code ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_code : "NA"
      currentTxn.EmployeeDepartment = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_department ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_department : "NA"
      currentTxn.EmployeeLocation = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_location ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_location : "NA"
      console.log("payoutref", payoutref)


      // currentTxn.EmployeeCode = 
      // currentTxn.EmployeeLocation = 
      // currentTxn.EmployeeDepartment = 
console.log("usersObj",usersObj)
      if (usersObj?.[Phonenumber]?.[payoutref]) {

        if (Phonenumber == "+918303163980") {
          // console.log("usersObj", usersObj)
          // console.log("payoutref",payoutref);

          // console.log("currentTxn", currentTxn);

        }


        let updation = usersObj?.[Phonenumber]?.[payoutref]
        if (updation.ApprovalCode) currentTxn.ApprovalCode = updation.ApprovalCode
        if (updation.Purpose) currentTxn.Purpose = updation.Purpose
        if (updation.tags) currentTxn.Tags = updation.tags
        if (updation.Category) currentTxn.Category_id = updation.Category

      }

      if (currentTxn.Category_id == "NA") {
        currentTxn.Category_id = "Uncategorised"
        currentTxn.GlCode = "NA"
      } else {

        currentTxn.GlCode = category[currentTxn.Category_id]?.gl_code ? category[currentTxn.Category_id]?.gl_code : "NA"
        currentTxn.Category_id = category[currentTxn.Category_id]?.CategoryName


      }
      data.transactions[i] = currentTxn
    }
    downloadCSV(data, FileName, date)

  }

  const downloadCSV = (data, FileName, date) => {

  // accepts the grouped { days } shape; a flat array or { transactions }
  // still works, so DownloadStatments needs no change
  const fallbackTxns = data?.transactions
    ? data.transactions
    : Array.isArray(data)
      ? data
      : [];
  const fallbackLast = fallbackTxns[fallbackTxns.length - 1];

  const days = data?.days?.length
    ? data.days
    : [{
        date: null,
        transactions: fallbackTxns,
        openingBalance: data?.openingBalance ?? data?.OpeningBalance ?? null,
        // single-day path: closing comes from the last transaction
        closingBalance:
          data?.closingBalance ??
          (fallbackLast
            ? { Balance: fallbackLast['Balance'], BalanceCrDr: fallbackLast['BalanceCrDr'] }
            : null),
      }];

  const firstTxn = days.flatMap(d => d.transactions || [])[0];
  if (!firstTxn) return;

  const headers = Object.keys(firstTxn);
  const esc = (v) => JSON.stringify(v ?? '');

  let balanceIdx = headers.indexOf('Balance');
  if (balanceIdx === -1) balanceIdx = 6;
  let crDrIdx = headers.indexOf('BalanceCrDr');
  if (crDrIdx === -1) crDrIdx = balanceIdx + 1;

  // builds a row aligned to the headers: label, amount, Cr/Dr — rest blank
  const balanceRow = (label, amount, crDr) => {
    const row = new Array(headers.length).fill('');
    row[Math.max(0, balanceIdx - 2)] = label;
    row[balanceIdx] = amount ?? '';
    if (crDrIdx < headers.length) row[crDrIdx] = crDr ?? '';
    return row.map(esc).join(',');
  };

  // handles both { Balance, BalanceCrDr } objects and a bare number
  const readBalance = (b) => {
    if (b === null || b === undefined) return { amount: '', crDr: '' };
    if (typeof b !== 'object') return { amount: b, crDr: 'Cr' };
    return {
      amount: b.Balance ?? b.balance ?? b.amount ?? '',
      crDr: b.BalanceCrDr ?? b.crDr ?? 'Cr',
    };
  };

  const opening = readBalance(days[0]?.openingBalance ?? data?.openingBalance);

  const lines = [
    balanceRow('Opening Balance', opening.amount, opening.crDr),
    headers.join(','),
  ];

  days.forEach(day => {
    (day.transactions || []).forEach(row =>
      lines.push(headers.map(h => esc(row[h])).join(','))
    );
    const closing = readBalance(day.closingBalance);
    lines.push(
      balanceRow(
        day.date ? `Closing Balance ${day.date}` : 'Closing Balance',
        closing.amount,
        closing.crDr
      )
    );
  });

  const csv = lines.join('\n');

  const monthNumber = monthOptions.indexOf(selectedMonth) + 1;
  const formattedMonth = String(monthNumber).padStart(2, "0");
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  if (date) {
    let day = String(date).slice(-2)
    a.download = `${selectedYear}-${formattedMonth}-${day}-CUPI-Statements.csv`;
  } else {
    a.download = `${selectedYear}-${selectedMonth}-CUPI-Statements.csv`;
  }
  a.click();
  URL.revokeObjectURL(url);
};

  const readCsvRaw = async (url) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch CSV: ${res.status}`);
    return await res.text();
  };

const handleFetchAndCombine = async (Docs, FileName) => {
  try {
    const sortedDocs = [...(Docs || [])].sort((a, b) =>
      String(a?.statement_name).localeCompare(String(b?.statement_name))
    );

    let days = []
    let openingBalance = null
    let lastKnownClosing = null

    for (let j = 0; j < sortedDocs.length; j++) {
      let url = sortedDocs[j]?.url
      const parts = String(sortedDocs[j]?.statement_name).split("-");
      const date = parts.slice(0, 3).join("");      // "20260812" — key format
      const dateLabel = parts.slice(0, 3).join("-"); // "2026-08-12" — CSV label

      let data = await useCsvEditor(url)

      if (j === 0) openingBalance = data.openingBalance
      let usersObj = {}
      const getUpdation = async (data, date, usersObj) => {
        for (let i = 0; i < data.transactions.length; i++) {
          let currentTxn = data.transactions[i]
          const clean = String(currentTxn["Employee Phone Number"]).replace(/^(\+91|91)/, '');
          let response
          if (!usersObj[currentTxn["Employee Phone Number"]]) {
            response = await GetUsersTaxUpdate(date, store.Company_Id, clean)
          }
          if (!usersObj[currentTxn["Employee Phone Number"]]) usersObj[currentTxn["Employee Phone Number"]] = response ? response : "NA"
        }
        return usersObj
      }
      usersObj = await getUpdation(data, date, usersObj)

      let updateNewTxn = []
      for (let i = 0; i < data.transactions.length; i++) {
        let currentTxn = data.transactions[i]
        let Phonenumber = currentTxn["Employee Phone Number"]
        let payoutref = currentTxn["Payout_Ref"]//currentTxn["Payout Ref"]
        currentTxn.EmployeeCode = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_code ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_code : "NA"
        currentTxn.EmployeeDepartment = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_department ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_department : "NA"
        currentTxn.EmployeeLocation = EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_location ? EmployeeInfo[currentTxn["Employee Phone Number"]]?.employee_location : "NA"

        if (usersObj?.[Phonenumber]?.[payoutref]) {
          let updation = usersObj?.[Phonenumber]?.[payoutref]
          if (updation.ApprovalCode) currentTxn.ApprovalCode = updation.ApprovalCode
          if (updation.Purpose) currentTxn.Purpose = updation.Purpose
          if (updation.tags) currentTxn.Tags = updation.tags
          if (updation.Category) currentTxn.Category_id = updation.Category
        }
        data.transactions[i] = currentTxn
        updateNewTxn.push(currentTxn)
        if (currentTxn.Category_id == "NA") {
          currentTxn.Category_id = "Uncategorised"
          currentTxn.GlCode = "NA"
        } else {
          currentTxn.GlCode = category[currentTxn.Category_id]?.gl_code ? category[currentTxn.Category_id]?.gl_code : "NA"
          currentTxn.Category_id = category[currentTxn.Category_id]?.CategoryName
        }
      }

      // closing for this date: parser value if it has one, else the last txn's
      // balance, else carry forward the previous date (a day with no activity)
      const lastTxn = updateNewTxn[updateNewTxn.length - 1]
      const closingBalance =
        data.closingBalance ??
        (lastTxn
          ? { Balance: lastTxn["Balance"], BalanceCrDr: lastTxn["BalanceCrDr"] }
          : lastKnownClosing)

      if (closingBalance) lastKnownClosing = closingBalance

      days.push({
        date: dateLabel,
        openingBalance: data.openingBalance,
        closingBalance,
        transactions: updateNewTxn,
      })
    }

    console.log("days", days)
    downloadCSV({ days, openingBalance }, FileName)
  } catch (err) {
    console.log("error from handleFetchAndCombine", err);
  }
}

  useEffect(() => {
    (async () => {
      if (!Clicked && gotResponse) {
        setShowSuccess(true);
        await new Promise((resolve) => setTimeout(resolve, 5000));
        setShowSuccess(false);
      }
    })();
  }, [Clicked]);

  return (
    <Fragment>
      {/* <div className={styles.NoteContainer}>
        <div className={styles.NoteContent}>
          <span className={styles.Bold}>Note:</span> The UTR for the wallet
          loads will not match because of an issue at Pine Labs PPI escrow
          account. We are working on updating the system to reflect the correct
          UTR. Please note that the amount and date will match.
        </div>
      </div> */}
      <div className={styles.Container}>
        <div className={styles.FilterContainer}>
          <div className={styles.FilterContainer1}>
            <select
              className={styles.Filter}
              value={selectedYear}
              onChange={async (e) => {
                setSelectedYear(e.target.value);
                GetStatementsData(e.target.value, selectedMonth);
                getRemarks(e.target.value, selectedMonth);
              }}
            >
              <option value="" disabled>
                Select Year
              </option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <select
              className={styles.Filter}
              value={selectedMonth}
              onChange={(e) => {
                setSelectedmonth(e.target.value);
                GetStatementsData(selectedYear, e.target.value);
                getRemarks(selectedYear, e.target.value);
              }}
            >
              <option value="" disabled>
                Select Month
              </option>
              {monthOptions.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <div className={styles.AlertContainer}>
              Note:{" "}
              <span className={styles.AlertSpan}>
                You can download statements only for the dates on which your
                employees spent with CUPI.
              </span>
            </div>
          </div>
          {/* {ShowSuccess && !Error && (
            <div className={styles.SuccessAlertContainer}>
              <img
                className={styles.filterLinesIcon}
                alt=""
                src="/check-circle.svg"
              />
              <span>Statements downloaded successfully!</span>
            </div>
          )} */}
          {Error && (
            <div className={styles.ErrorAlertContainer}>
              <div>{ErrorMsg.Title}</div>
              <span className={styles.ErrorAlertSpan}>{ErrorMsg.message}!</span>
            </div>
          )}
        </div>
        <div className={styles.tableContainer}>
          {selectedYear && gotResponse && data.length > 0 && (
            <div className={styles.GenerateMonthlyReport}>
              <div className={styles.GenerateMonthlyContainer1}>
                <div className={styles.GenerateMonthlyNote}>
                  <span className={styles.Bold}>Note:</span> You can generate a
                  single file that includes all the user spending statements
                  available so far for this month.
                </div>
                <div
                  className={styles.GenerateMonthlyDate}
                >{`${selectedYear}-${selectedMonth}-CUPI-Statement.csv`}</div>
              </div>
              <div className={styles.GenerateMonthlyContainer2}>
                {!DownloadingProgess ? (
                  <div
                    className={styles.GenerateMonthlyButton}
                    onClick={async () => {
                      setDownloadingProgess(true);
                      console.log("data", data)
                      const monthNumber =
                        monthOptions.indexOf(selectedMonth) + 1;
                      const formattedMonth = String(
                        monthNumber,
                      ).padStart(2, "0");
                      // const result = res.statement_name.split("-").slice(0, 3).join("");
                      await handleFetchAndCombine(data, `${selectedYear}-${selectedMonth}-CUPI-Statement.csv`);
                      setDownloadingProgess(false);
                    }}
                  >
                    <img
                      className={styles.filterLinesIcon}
                      alt=""
                      src="/Generate_Report_icon.svg"
                    />
                    <span className={styles.underline}>Generate</span>
                  </div>
                ) : (
                  <div className={styles.GenerateMonthlyButton}>
                    <img
                      className={styles.filterLinesIcon}
                      alt=""
                      src="/Blue_Download_Icon.svg"
                    />
                    <span className={styles.underline}>Downloading...</span>
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedYear && gotResponse && data?.length > 0 ? (
            <table className={styles.ReportTable}>
              <tbody className={styles.TableBody}>
                {data?.map((res) => {
                  let value = res?.statement_name.split("-");
                  let key = value[0] + value[1] + value[2];

                  return (
                    <tr key={res.statement_name} className={styles.TableRow}>
                      <td className={styles.TableRemark}>
                        {res?.statement_name}
                      </td>
                      {!Remarks?.[key] ? (
                        <td className={styles.TableMonth}>
                          <button
                            className={styles.RemarkEditButton}
                            onClick={() => {
                              const monthNumber =
                                monthOptions.indexOf(selectedMonth) + 1;
                              const formattedMonth = String(
                                monthNumber,
                              ).padStart(2, "0");
                              let obj = {
                                year: selectedYear,
                                month: formattedMonth,
                                remark: "",
                                filename: res?.statement_name,
                              };
                              console.log("Clicked Object ", obj);

                              store.setRemarks(obj);

                              setEditRemark(true);
                            }}
                          >
                            <img
                              className={styles.filterLinesIcon}
                              alt=""
                              src="/edit-02.svg"
                            />
                            Add Remarks
                          </button>
                        </td>
                      ) : (
                        <td
                          className={styles.TableRemark}
                          title={Remarks?.[key] || "N/A"} // ← Full text shows on hover
                        >
                          <button
                            className={styles.RemarkEditButton}
                            onClick={() => {
                              const monthNumber =
                                monthOptions.indexOf(selectedMonth) + 1;
                              const formattedMonth = String(
                                monthNumber,
                              ).padStart(2, "0");

                              let obj = {
                                year: selectedYear,
                                month: formattedMonth,
                                remark: Remarks?.[key],
                                filename: res?.statement_name,
                              };

                              console.log("Clicked Object ", obj);
                              store.setRemarks(obj);
                              setEditRemark(true);
                            }}
                          >
                            <img
                              className={styles.filterLinesIcon}
                              alt=""
                              src="/edit-02.svg"
                            />
                          </button>

                          {/* Display truncated text */}
                          {Remarks?.[key]
                            ? `${Remarks[key].length > 56
                              ? `${Remarks[key].substring(0, 56)}...`
                              : Remarks[key]
                            }`
                            : "N/A"}
                        </td>
                      )}
                      <td className={styles.TableButton}>
                        {Clicked && ClickedStmt == res?.statement_name ? (
                          <button className={styles.GenerateButtonDis}>
                            <img
                              className={styles.filterLinesIcon}
                              alt=""
                              src="/Blue_Download_Icon.svg"
                            />
                            <span className={styles.GenerateButtonText}>
                              Downloading...
                            </span>
                          </button>
                        ) : (
                          <button
                            className={styles.GenerateButton}
                            onClick={async () => {
                              // setClicked(true);
                              setClickedStmt(res.statement_name);
                              const result = res.statement_name.split("-").slice(0, 3).join("");

                              await DownloadStatments(res.url, result)
                              // await new Promise((resolve) =>
                              //   setTimeout(resolve, 1500),
                              // );
                              // setClicked(false);
                            }}
                          >
                            <img
                              className={styles.filterLinesIcon}
                              alt=""
                              src="/Blue_Download_Icon.svg"
                            />
                            <span className={styles.GenerateButtonText}>
                              Download
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={styles.NoTableData}>
              No statements found. Please select a valid year and month to view
              your statement.
            </div>
          )}
        </div>
      </div>
      {EditRemark && (
        <div className={styles.newUsersOverlay1}>
          <AddRemark
            isVisible={EditRemark}
            onClose={() => {
              getRemarks(selectedYear, selectedMonth);
              setEditRemark(false);
            }}
          />
        </div>
      )}
    </Fragment>
  );
});

export default Statement;
